import { createClient } from '@supabase/supabase-js'

const runtime = window.__APP_CONFIG__ || {}
const url = runtime.SUPABASE_URL || import.meta.env.VITE_SUPABASE_URL || ''
const key =
  runtime.SUPABASE_ANON_KEY ||
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  ''

export const supabasePublicUrl = url
export const supabaseAnonKey = key

export const supabaseConfigured = Boolean(url && key)

export const supabase = createClient(url || 'https://not-configured.invalid', key || 'not-configured', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storageKey: 'cooper-eng-test-auth',
  },
})
